import { useState, useEffect } from "react";
import {
    IonApp,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonFooter,
    IonMenu,
    IonList,
    IonListHeader,
    IonSelect,
    IonSelectOption,
    IonAccordion,
    IonRow,
    IonGrid,
    IonModal,
    IonCol,
    IonAccordionGroup,
    IonMenuToggle,
    IonIcon,
    IonDatetimeButton,
    IonDatetime,
    IonLabel,
    IonPage,
    IonButtons,
    IonButton,
    IonItem,
    IonRadioGroup,
    IonRadio,
    IonItemDivider,
  } from "@ionic/react";

import { getTripDetail}  from "../pages/deliveries/services/apiService"

function TripDetailModal(props) {

  const [tripDetails, setTripDetails] = useState({})
  const [showData, setShowData] = useState(false)
  useEffect(()=>{
    getTripInformation()
  },[])

  const getTripInformation = async () => {
    let response = await getTripDetail(props.tripId)
    
    setTripDetails(response.result)
    setShowData(true)
    return 
   
  }
  
    return (
        <>
           <IonContent className="ion-padding view-details-popup">
                 
                 <div className='popup-header'>
                  <IonGrid>
                    <IonRow>
                    <p className="close-outline" onClick={() => props.setIsOpen(false)}>X</p>
                      <IonCol>
                        <h1>Delivery Details</h1>
                        <p>ID: {props.tripId} </p>
                      </IonCol>
                      <IonCol>
                        
                      </IonCol>
                    </IonRow>
                    
                  </IonGrid>
                </div>
                 <div className='accordion-wrapper order-summary view-details-popup'>
            
            <IonGrid>
              <div className='top-grid'>
              <IonRow>
              { showData && 
                  <>
                      <IonCol>
                        
                        
                        <div className='col-heading'>Pick up</div>
                        <div className='col-details'><span><img src='../img/location.png'></img> </span>{tripDetails.startLocation.address}</div>
                        <div className='col-details'><span><img src='../img/person.png'></img> </span>{tripDetails.multipleDeliveryDetails[0].senderName}</div>
                        <div className='col-details'><span><img src='../img/call.png'></img> </span>{tripDetails.multipleDeliveryDetails[0].senderMobileNumber}</div>
                        
                        </IonCol>
                      <IonCol>
                        <div className='col-heading'>Payment Method</div>
                        <div className='col-details'><span><img src='../img/mastercard.png'></img> </span>{tripDetails.cardType === 'Coin' ? "RydeCoin" : tripDetails.cardType + "***" + tripDetails.last4}<br/>
                          ${tripDetails.price} incl/GST</div>
                        
                      </IonCol>
                    
                  </>
                }
                </IonRow>
              </div>
                    
                    
                  </IonGrid>  
            <hr/> 
            <div className='col-heading'>Deliver to</div>
            <ion-list>
                        {
                          showData && tripDetails.additionalStops &&
                          
                          tripDetails.additionalStops.map((stop, i ) => {

                            if (i === 0) {
                              return (<>

                                  <div className='first'>
                                    <IonItem slot="header" color="light"> 
                                    <IonLabel>{stop.address} <p>Unit : #{tripDetails.multipleDeliveryDetails[i+1].receiverFloor}-{tripDetails.multipleDeliveryDetails[i+1].receiverUnit}   |   Contact : {tripDetails.multipleDeliveryDetails[i+1].receiverName}   |   Number : {tripDetails.multipleDeliveryDetails[i+1].receiverMobileNumber} </p> </IonLabel>
                                    </IonItem>
                                  </div>
                              
                              
                              </>)
                            }

                            else {
                              <IonItem slot="header" color="light"> 
                              <IonLabel>{stop.address} <p> Unit : #{tripDetails.multipleDeliveryDetails[i+1].receiverFloor}-{tripDetails.multipleDeliveryDetails[i+1].receiverUnit}   |   Contact : {tripDetails.multipleDeliveryDetails[i+1].receiverName}   |   Number : {tripDetails.multipleDeliveryDetails[i+1].receiverMobileNumber} </p> </IonLabel>
                              </IonItem>
                            } 
                          })
                        }
                        {showData &&
                          <div className='last'>
                            <IonItem slot="header" color="light">
                            <IonLabel>{tripDetails.endLocation.address} <p>Unit : #{tripDetails.multipleDeliveryDetails[tripDetails.multipleDeliveryDetails.length-1].receiverFloor}-{tripDetails.multipleDeliveryDetails[tripDetails.multipleDeliveryDetails.length-1].receiverUnit}   |   Contact : {tripDetails.multipleDeliveryDetails[tripDetails.multipleDeliveryDetails.length-1].receiverName}   |   Number : {tripDetails.multipleDeliveryDetails[tripDetails.multipleDeliveryDetails.length-1].receiverMobileNumber} </p> </IonLabel>
                            </IonItem>
                          </div>
                        }
            </ion-list>      
                   
            </div>
                   
                 </IonContent>
        </>
    )
}

export default TripDetailModal;